import { format, isValid, parseISO } from 'date-fns';

import { Alert } from '@liscio/ui';

const SENT_AT_FORMAT = "MMM d, yyyy 'at' h:mm a";

interface RfiSentNoticeProps {
  visible: boolean;
  sentAt?: string | null;
}

export const RfiSentNotice = ({ visible, sentAt }: RfiSentNoticeProps) => {
  if (!visible || !sentAt) return null;
  const date = parseISO(sentAt);
  if (!isValid(date)) return null;

  return (
    <Alert
      severity="success"
      role="status"
      // The default success icon color is below 3:1 on this background.
      sx={{ m: 2, '& .MuiAlert-icon': { color: 'success.dark' } }}
    >
      Sent to client on {format(date, SENT_AT_FORMAT)}
    </Alert>
  );
};
